import React, {useEffect, useRef, useState} from 'react'

// react redux
import { connect } from 'react-redux'

// react router
import { Link } from 'react-router-dom'

// bootstrap
import { Container, Spinner } from 'react-bootstrap'
// icons : feather
import FeatherIcon from 'feather-icons-react';

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// form fields
import ShippingMultiplierInput from './includes/ShippingMultiplierInput'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

// API
import { getShippingMultiplierApi, addShippingMultiplierApi } from 'utlis/Apis/Multipliers_API';

// toast
import { toast } from 'react-toastify'

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED
} from 'utlis/AppMessages/AppMessages'

import { setGlobalLoading } from 'redux/actions/actionCommon';
import { debounce } from 'utlis/helpers/Common/CommonHelperFunctions';

function ShippingMultiplier(props) {
    // props
    const { authState, setGlobalLoading, commonToken } = props

    // refs
    const submitBtnRef = useRef(null)

    // store url
    const [storeUrl] = useStoreUrl()

    // states
    const [btnLoading, setBtnLoading] = useState(false)
    const [btnDisabled, setBtnDisabled] = useState(false)

    // initial form values
    const initialFormValues = {
        allValues: [{
            from: "",
            isUp: true,
            to: "",
            ratePerOrder: ""
        }]
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        allValues: Yup.array().of(
            Yup.object().shape({
                from: Yup.string().required("This field is required"),
                isUp: Yup.boolean(),
                to: Yup.string().when("isUp", {
                    is: false,
                    then: Yup.string().required("This field is required")
                }),
                ratePerOrder: Yup.string().required("This field is required")
            })
        )
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            console.log("values ", values);

            const requiredData = {
                range_from: values.allValues.map(item => item.from ? item.from : "0"),
                range_to: values.allValues.map(item => item.to ? item.to : "0"),
                price: values.allValues.map(item => item.ratePerOrder ? item.ratePerOrder : "0")
            }

            // loading
            setBtnLoading(true)
            setBtnDisabled(true)

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            addShippingMultiplierApi(headers, requiredData).then(res => {
                const resData = res.data

                // loading
                setBtnLoading(false)
                setBtnDisabled(false)

                // console.log("resData ", resData);

                // if successfully created
                if (resData.success) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing success message
                    toast.success("Updated Successfully", {
                        autoClose: 2000,
                        onClose: () => {}
                    })
                }

                // if some error
                if (resData.error) {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData.message || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} get addShippingMultiplierApi `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // loading
                        setBtnLoading(false)
                        setBtnDisabled(false)
                    }
                })
            })

        }
    }

    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    useEffect(() => {
        // global loading
        setGlobalLoading(true)  

        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getShippingMultiplierApi(headers).then(res => {
            const resData = res.data

            // global loading
            setGlobalLoading(false)

            console.log("resData ", resData);

            // if successfully created
            if (resData.success) {
                const dataArr = []
                resData?.data?.forEach(item => {
                    dataArr.push({
                        from: item.range_from,
                        isUp: (item.range_to === 0) ? true : false,
                        to: item.range_to,
                        ratePerOrder: item.price
                    })
                })

                if(dataArr?.length) {
                    formik.setFieldValue("allValues", dataArr?.length)
                }
            }

            // if some error
            if (resData?.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // global loading
                        setGlobalLoading(false)
                    }
                })
            }

        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} get getShippingMultiplierApi `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // global loading
                    setGlobalLoading(false)
                }
            })
        })
    }, [commonToken])

    
    // add more fields
    const addMoreField = ev => {
        ev.preventDefault()

        if(formik?.values?.allValues?.length) {
            const singleItem = formik.values.allValues[formik.values.allValues.length - 1]

            // console.log("singleItem ", singleItem);
            // console.log("!singleItem.ratePerOrder ", !singleItem.ratePerOrder);

            if((singleItem.from) && (singleItem.to) && (singleItem.ratePerOrder)) {
                const from = parseInt(singleItem.to) + 0.01
                formik.setFieldValue("allValues", [...formik.values.allValues, {
                    from,
                    isUp: true,
                    to: "",
                    ratePerOrder: "",
                }])
            } else {
                if(Object.keys(formik.errors)?.length) {
                    submitBtnRef.current.click()
                } else {
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing success message
                    toast.info("Please select Subtotal Range (To) value to add a new row", {
                        autoClose: 2500,
                        onClose: () => {}
                    })
                }
            }
        }
    }

    // handle andup button clicked
    const handleAndUp = (ev, itemIndex) => {
        ev.preventDefault()

        // filtering
        const updatedValues = formik.values.allValues.map((item, index) => {
            if(index === itemIndex) {
                return {
                    ...item,
                    isUp: false
                }
            }
            return item
        })

        // setting a new field data
        formik.setFieldValue("allValues", updatedValues)
    }

    // handle delete button clicked
    const handleDelete = (ev, itemIndex) => {
        ev.preventDefault()

        // filtering
        const updatedValues = formik.values.allValues.filter((item, index) => index !== itemIndex)

        // setting a new field data
        formik.setFieldValue("allValues", updatedValues)
    }

    // handle to change
    const handleToChange = debounce((ev, itemIndex) => {
        // const inpVal = ev.target.value
        // const currentItem = formik.values.allValues[itemIndex]

        // if(inpVal < currentItem.from) {
        //     console.log("currentItem ", currentItem);
        //     formik.setFieldError(`allValues.${itemIndex}.to`, "(To) value can not be less than (From) value")
        //     formik.setFieldTouched(`allValues.${itemIndex}.to`, true)
        // }        
    }, 1000)

    return (
        <section id="app-multipliers" className="st-def-mar-TB page-eorc-wrapper wrapper-shipping-multipliers">
            <Container fluid className="st-container">
                <div className="app-multipliers">
                    
                    {/* BACK BUTTON WRAPPER */}
                    <div className="back-button-wrapper st-line-height-0 mb-3">
                        <Link to={storeUrl + "/catalog/multipliers"}
                            // onClick={ev => {
                            // 	ev.preventDefault()
                            // 	history.goBack()
                            // }}
                            className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-14 st-fw-600">
                            <FeatherIcon
                                icon="arrow-left"
                                size="16"
                                className="icon me-1" />
                            <span>Back to Multipliers</span>
                        </Link>
                    </div>

                    <div className="content-wrapper">
                        {/* page border box */}
                        <div className="page-border-box mb-4">
                            <div className="pbb-inner position-relative">
                                {/* header */}
                                <div className="app-header-wrapper heading-sm">
                                    <p className="app-heading text-capitalize">Select Shipping Rates</p>
                                </div>

                                <div className="form-content col-12 col-xl-8">
                                    <form onSubmit={formik.handleSubmit}
                                        noValidate
                                        autoComplete="off">
                                        {
                                            // console.log("formik.errors", formik)
                                        }
                                        {/* {
                                            console.log("formik.touched", formik.touched)
                                        } */}
                                        {/* item */}
                                        {
                                            formik?.values?.allValues?.length ? formik.values.allValues.map((item, index) => {
                                                return(
                                                    <div key={index} className={`all-form-items item mb-3`}>
                                                        {/* ${(formik.values.allValues[index].from) ? "disabled-elem" : ""}` */}
                                                        <div className="inner d-flex flex-wrap mb-3">
                                                            {/* form item */}
                                                            <div className="form-item pe-lg-3">
                                                                <ShippingMultiplierInput
                                                                    inputType={"number"}
                                                                    formik={formik}
                                                                    stFormClass={`mb-0`}
                                                                    isRequired={true}
                                                                    labelName={`Weight range (From)`}
                                                                    formikFieldName={"from"}
                                                                    formikFieldIndex={index}
                                                                    addLabel="$"
                                                                    isDisabled={(index > 0) ? true : false}
                                                                />
                                                            </div>

                                                            {/* form item */}
                                                            <div className="form-item pe-lg-3">
                                                                {
                                                                    item.isUp ? (
                                                                        <p className="d-flex align-items-center" style={{minWidth: 150, paddingTop: 34}}>
                                                                            <span className="me-2 position-relative" style={{top: -5}}>_</span>
                                                                            <span className="st-fw-600 st-text-primary cursor-pointer" onClick={ev => handleAndUp(ev, index)}>And Up</span>
                                                                        </p>
                                                                    ) : (
                                                                        <ShippingMultiplierInput
                                                                            inputType={"number"}
                                                                            formik={formik}
                                                                            stFormClass={`mb-0`}
                                                                            isRequired={true}
                                                                            labelName={`Weight range (To)`}
                                                                            formikFieldName={"to"}
                                                                            formikFieldIndex={index}
                                                                            addLabel="$"
                                                                            onChange={(ev) => handleToChange(ev, index)}
                                                                        />
                                                                    )
                                                                }
                                                            </div>

                                                            {/* form item */}
                                                            <div className="form-item ps-lg-4 position-relative">
                                                                <ShippingMultiplierInput
                                                                    inputType={"number"}
                                                                    formik={formik}
                                                                    stFormClass={"mb-1"}
                                                                    isRequired={true}
                                                                    labelName={"Rate per order"}
                                                                    formikFieldName={"ratePerOrder"}
                                                                    formikFieldIndex={index}
                                                                    addLabel={"$"}
                                                                />

                                                                {/* delete icon */}
                                                                <div className="delete-icon position-absolute">
                                                                    <a href="#" className="delete st-round-btn st-btn-xs d-flex align-items-center justify-content-center" onClick={ev => {
                                                                        if (index > 0) {
                                                                            handleDelete(ev, index)
                                                                        }
                                                                    }} style={{
                                                                        opacity: (index < 1) ? 0 : 1,
                                                                        cursor: (index < 1) ? "default" : "pointer",
                                                                    }}>
                                                                        <FeatherIcon
                                                                            icon="trash"
                                                                            size="15"
                                                                            className="icon" />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }) : null
                                        }

                                        {/* item */}
                                        <div className="add-row-btn item mb-3 pb-3">
                                            <a href="" className="st-btn st-btn-white-gray-outlined st-btn-sm text-center no-min-width" onClick={addMoreField}>Add Row</a>
                                        </div>

                                        {/* item */}
                                        <div className="submit-btn item">
                                            <button 
                                                type="submit" 
                                                ref={submitBtnRef} 
                                                className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${btnDisabled ? "disabled-elem" : ""}`}>
                                                    {
                                                        btnLoading ? (
                                                            <Spinner animation="border" size="sm" />
                                                        ) : (
                                                            <span>Save</span>
                                                        )
                                                    }
                                                </button>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>




                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        commonToken: state.auth.commonToken,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: (prop) => dispatch(setGlobalLoading(prop)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(ShippingMultiplier)